var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-radio-group",
    {
      staticClass: "language-radio-buttons",
      attrs: { size: "mini" },
      model: {
        value: _vm.currentValue,
        callback: function ($$v) {
          _vm.currentValue = $$v
        },
        expression: "currentValue",
      },
    },
    _vm._l(_vm.langOptions, function (opt) {
      return _c(
        "el-radio-button",
        { key: opt.value, attrs: { label: opt.value } },
        [_vm._v(" " + _vm._s(opt.label) + " ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }